export default {
	1: "error",
	2: "info",
	3: "success",
	4: "warning"
};
